import createApiClient from '../utils/apiClient';

const api = createApiClient();

export interface Channel {
  id: number;
  channel_id: string;
  platform: 'twitch' | 'youtube' | 'kick';
  channelName?: string;
  profilePicture?: string;
  notifications_count: number;
  created_at: Date;
  updated_at: Date;
}

class ChannelService {
  async getTopChannels(limit: number = 10): Promise<Channel[]> {
    const response = await api.get(`/channels/top`, {
      params: { limit }
    });
    return response.data;
  }
}

export default new ChannelService();
